import React, { useState, useEffect, useCallback, useRef } from "react";
import "../Assets/styles/newStyles/AssessmentModal.css";
import { NotificationManager } from "react-notifications";
import axios from "../axios";
import Switch from "react-switch";
import DownArrow from "../Assets/images/down-arrow.png";
import UpArrow from "../Assets/images/up-arrow.png";
import { useParams } from "react-router-dom";
import moment from "moment";
import Select from "react-select";
import DownloadIcon from "../Assets/images/DownloadIcon.png";
import { DynamicReports } from "./DynamicReports";
import { AudioPlayer } from "./AudioPlayer";
import { LabelReadMode } from "./LabelReadMode";
import RemoveRectangle from "../Assets/images/remove-rectangle.svg";

import WaveSurfer from "wavesurfer.js";
// import {AudioPlayer} from './AudioPlayer'
import { tr } from "date-fns/locale";
import ClipLoader from "react-spinners/ClipLoader";

export const AssessmentModal = (props) => {
  const { onClose, data, name, record, showModal } = props;
  const { symptoms, feedback, medicalConditions, profileIcon } = data;
  var recordIdInitial = props.data.recordId;
  // console.log(data);
  const [pdfData, setPdfData] = React.useState([]);
  const [medicalConditionsToggle, setMedicalConditionsOpen] =
    React.useState(false);
  const [labelDataToggle, setLabelDataOpen] = React.useState(false);
  const [downloadLoading, setDownloadLoading] = React.useState(false);
  const [feedbackToggle, setFeedbackOpen] = React.useState(false);
  const [vitalsAndSymptomsToggle, setVitalsAndSymptomsOpen] =
    React.useState(false);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const params = useParams();
  const [selectedCoughOptions, setSelectedCoughOptions] = React.useState([]);
  const [selectedDiseaseOptions, setSelectedDiseaseOptions] = React.useState(
    []
  );
  const [selectedPatternOptions, setSelectedPatternOptions] = React.useState(
    []
  );
  const [selectedSeverityOption, setSelectedSeverityOption] = React.useState(
    []
  );
  const [selectedAnatomyOptions, setSelectedAnatomyOptions] = React.useState(
    []
  );
  const [selectedLabelTypeOption, setSelectedLabelTypeOption] = React.useState(
    []
  );
  const [isLabelTypeRequired, setIsLabelTypeRequired] = useState(false);
  const [commentType, setCommentType] = React.useState("");
  const [labelData, setLabelData] = React.useState(
    data.labelData === null ? [] : data.labelData
  );
  const [showLabelData, setShowLabelData] = React.useState(false);
  const [editIndex, setEditIndex] = React.useState(-1);
  const [hide, setHide] = React.useState(false);

  useEffect(() => {
    console.log(props.data);
    recordIdInitial = props.data.recordId;
  }, []);

  const coughOptions = [
    { value: "Dry", label: "Dry" },
    { value: "Wet", label: "Wet" },
    { value: "Whooping", label: "Whooping" },
  ];

  const diseaseOptions = [
    { value: "Normal", label: "Normal" },
    { value: "Allergy", label: "Allergy" },
    { value: "Asthma", label: "Asthma" },
    { value: "Bronchieatasis", label: "Bronchieatasis" },
    { value: "COPD", label: "COPD" },
    { value: "COVID-19", label: "COVID-19" },
    { value: "Mass Lesion", label: "Mass Lesion" },
    { value: "Pneumonia", label: "Pneumonia" },
    { value: "Synpneumonic Effusion", label: "Synpneumonic Effusion" },
    { value: "Thymoma", label: "Thymoma" },
    {
      value: "Bilateral Upper Lobe Fibrosis",
      label: "Bilateral Upper Lobe Fibrosis",
    },
    { value: "Lung Cancer", label: "Lung Cancer" },
    { value: "ILD", label: "ILD" },
    { value: "TB", label: "TB" },
    { value: "Other", label: "Other" },
  ];
  console.log(showModal);
  const patternOptions = [
    { value: "Normal", label: "Normal" },
    { value: "Obstructive", label: "Obstructive" },
    { value: "Restrictive", label: "Restrictive" },
    { value: "Mixed", label: "Mixed" },
  ];

  const severityOptions = [
    { value: "Normal", label: "Normal" },
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
  ];

  const anatomyOptions = [
    { value: "NA", label: "NA" },
    { value: "Small Airways", label: "Small Airways" },
    { value: "Large Airways", label: "Large Airways" },
    { value: "Parenchyma", label: "Parenchyma" },
    { value: "Limited Parenchyma", label: "Limited Parenchyma" },
    {
      value: "Extensive Involvement Parenchyma",
      label: "Extensive Involvement Parenchyma",
    },
    { value: "Pleura", label: "Pleura" },
  ];

  const labelTypeOptions = [
    { value: "Provisional", label: "Provisional" },
    { value: "Diagnosis", label: "Diagnosis" },
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "98%",
      fontSize: "13px",
      margin: "0px",
      marginTop: "2px",
      borderRadius: "4px",
      borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
        : null,
      "&:hover": {
        borderColor: state.isFocused ? "#80bdff" : "#adb5bd",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: state.isFocused ? "#ffe8cf" : null,
      color: state.isDisabled ? "#ccc" : "#495057",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#fac055 ",
      borderRadius: "2px",
      // color: 'white',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      fontSize: "12px",
      "&:hover": {
        backgroundColor: "transparent",
        color: "#0056b3",
      },
    }),
    menu: (provided) => ({
      ...provided,
      width: "300px", // Adjust the width of the options container
      borderRadius: "4px",
      marginLeft: "10px",
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "300px", // Adjust the height of the options container
      fontSize: "14px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontFamily: "Roboto", // Change the font family here
      lineHeight: "normal",
    }),
  };
  // console.log(data);

  const handlePdfUpload = (pdfData) => {
    setPdfData(pdfData);
  };
  // console.log(pdfData)

  const getDownloadedAssessmentReport = () => {
    setDownloadLoading(true);
    try {
      axios
        .get(
          `/generate_assessment_report?userId=${encodeURIComponent(
            data.doctorId
          )}&recordId=${data.recordId}&diagnostic_report=False`,
          {
            headers: { accessToken: localStorage.accessToken },
            responseType: "blob",
          }
        )
        .then((response) => {
          setDownloadLoading(false);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${props.name}.pdf`); // or any other extension
          document.body.appendChild(link);
          link.click();
          NotificationManager.success("Download Successful", "Success", 3000);
        })
        .catch((error) => {
          setDownloadLoading(false);
          console.error("Error fetching the assessment report:", error);
          if (error.response.data.message) {
            NotificationManager.error(
              error.response.data.message,
              "Error",
              5000
            );
          } else {
            NotificationManager.error("can not download file", "Error", 5000);
          }
        });
    } catch (error) {
      setDownloadLoading(false);
      console.error("Error in getDownloadedAssessmentReport:", error);
      if (error.data.message) {
        NotificationManager.error(error.data.message, "Error", 5000);
      } else {
        NotificationManager.error("can not download file", "Error", 5000);
      }
    }
  };

  const changeCough = (selectedOptions) => {
    setSelectedCoughOptions(selectedOptions);
  };

  const changeDisease = (selectedOptions) => {
    setSelectedDiseaseOptions(selectedOptions);
  };

  const changePattern = (selectedOptions) => {
    setSelectedPatternOptions(selectedOptions);
  };

  const changeSeverity = (selectedOption) => {
    setSelectedSeverityOption([selectedOption]);
  };

  const changeAnatomy = (selectedOptions) => {
    setSelectedAnatomyOptions(selectedOptions);
  };

  const changeLabelType = (selectedOption) => {
    setSelectedLabelTypeOption([selectedOption]);
    setIsLabelTypeRequired(false);
  };

  const isOptionDisabled = (option) => {
    return selectedCoughOptions.some(
      (selectedOption) => selectedOption.value === option.value
    );
  };

  console.log(data);

  const saveLabel = async () => {
    try {
      if (!selectedLabelTypeOption || selectedLabelTypeOption.length === 0) {
        setIsLabelTypeRequired(true);
        return;
      }
      setLoading(true);

      const formattedCough = selectedCoughOptions
        .map((option) => option.value)
        .join(",");
      const formattedDisease = selectedDiseaseOptions
        .map((option) => option.value)
        .join(",");
      const formattedPattern = selectedPatternOptions
        .map((option) => option.value)
        .join(",");
      const formattedAnatomy = selectedAnatomyOptions
        .map((option) => option.value)
        .join(",");

      const severityType =
        selectedSeverityOption.length === 0
          ? ""
          : selectedSeverityOption[0].value;
      const labelType =
        selectedLabelTypeOption.length === 0
          ? ""
          : selectedLabelTypeOption[0].value;
      console.log(severityType);
      console.log(labelType);

      const labelData = {
        patternType: formattedPattern,
        DiseaseType: formattedDisease,
        coughType: formattedCough,
        anatomyType: formattedAnatomy,
        severityType: severityType,
        labelType: labelType,
        comments: commentType,
      };

      const formData = new FormData();

      formData.append("doctorId", params.doctorId || "");
      formData.append("patient_id", decodeURIComponent(params.patientId) || "");
      formData.append("record_id", data.recordId || "");
      formData.append("fileName", data.recordId || "");
      formData.append("labelData", JSON.stringify(labelData));

      console.log(labelData, "going");

      await axios({
        method: "POST",
        url: "/labelRecord",
        data: formData,
        headers: {
          accessToken: localStorage.accessToken,
        },
      })
        .then((response) => {
          setLoading(false);
          setShowLabelData(false);
          getPatientRecords1();
          NotificationManager.success("Success", "Label Data Updated", 5000);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error saving label:", error);
        });
    } catch (ex) {
      setLoading(false);
      console.log(ex);
    }
  };

  // score and feedback state
  const patientId = decodeURIComponent(params.patientId);
  const doctorId = params.doctorId;
  const getPatientRecords1 = async () => {
    try {
      setLoading(true);
      let formdata = new FormData();
      formdata.append("patientId", patientId.toString());
      formdata.append("doctorId", doctorId);

      const response = await axios.post(`/getPatientRecords`, formdata, {
        headers: {
          accessToken: localStorage.accessToken,
        },
      });

      if (!response.data.message) {
        const successRecords = response.data.records.filter(
          (record) => record.status === "SUCCESS"
        );

        // console.log("filtered records", successRecords);
        const successRecordsCopy = [...successRecords];
        const sortedRecords = successRecordsCopy.sort((a, b) => {
          const dateA = new Date(a.timestamp + " GMT+0530");
          const dateB = new Date(b.timestamp + " GMT+0530");
          return dateB - dateA; // Sort in descending order
        });
        // successRecords.sort((a, b) => {
        //   const dateA = new Date(a.timestamp + ' GMT+0530');
        //   const dateB = new Date(b.timestamp + ' GMT+0530');
        //   return dateB - dateA; // Sort in descending order
        // });

        const records = successRecords;

        const index = sortedRecords.findIndex(
          (record) => record.recordId === recordIdInitial
        );
        setRecords(sortedRecords);
        if (index !== -1) {
          // Index found, do something with it
          console.log("Index found:", index);
          // You can access the record at this index like sortedRecords[index]

          setLabelData(sortedRecords[index].label);
          setLoading(false);
        } else {
          // Index not found
          console.log("Index not found for recordId:", recordIdInitial);

          setLoading(false);
        }

        console.log(sortedRecords[0].recordId);
        console.log(recordIdInitial);
      }
    } catch (error) {
      console.log("Error fetching patient details:", error);
      setLoading(false);
    }
    // setLoader(true)
  };
  const [riskAcceptanceToggle, setriskAcceptanceToggle] = React.useState(
    feedback
      ? feedback.risk_acceptance === null
        ? true
        : parseInt(feedback.risk_acceptance)
      : true
  );

  const [riskAcceptanceComment, setriskAcceptanceComment] = React.useState(
    feedback
      ? feedback.risk_acceptance_comments === null
        ? ""
        : feedback.risk_acceptance_comments
      : ""
  );

  const [covidriskAcceptanceToggle, setcovidriskAcceptanceToggle] =
    React.useState(
      feedback
        ? feedback.covid_tb_pred
          ? feedback.covid_tb_pred.covid_acceptance === null
            ? true
            : parseInt(feedback.covid_tb_pred.covid_acceptance)
          : true
        : true
    );

  const [covidriskAcceptanceComment, setcovidriskAcceptanceComment] =
    React.useState(
      feedback
        ? feedback.covid_tb_pred
          ? feedback.covid_tb_pred.covid_acceptance_comments === null
            ? ""
            : feedback.covid_tb_pred.covid_acceptance_comments
          : ""
        : ""
    );

  const [tbriskAcceptanceToggle, settbriskAcceptanceToggle] = React.useState(
    feedback
      ? feedback.covid_tb_pred
        ? feedback.covid_tb_pred.tb_acceptance === null
          ? true
          : parseInt(feedback.covid_tb_pred.tb_acceptance)
        : true
      : true
  );

  const [tbriskAcceptanceComment, settbriskAcceptanceComment] = React.useState(
    feedback
      ? feedback.covid_tb_pred
        ? feedback.covid_tb_pred.tb_acceptance_comments === null
          ? ""
          : feedback.covid_tb_pred.tb_acceptance_comments
        : ""
      : ""
  );

  const [severityAcceptanceToggle, setseverityAcceptanceToggle] =
    React.useState(
      feedback
        ? feedback.severity_acceptance === null
          ? true
          : parseInt(feedback.severity_acceptance)
        : true
    );

  const [severityAcceptanceComment, setseverityAcceptanceComment] =
    React.useState(
      feedback
        ? feedback.severity_acceptance_comments === null
          ? ""
          : feedback.severity_acceptance_comments
        : ""
    );

  const [patternAcceptanceToggle, setpatternAcceptanceToggle] = React.useState(
    feedback
      ? feedback.pattern_acceptance === null
        ? true
        : parseInt(feedback.pattern_acceptance)
      : true
  );

  const [patternAcceptanceComment, setpatternAcceptanceComment] =
    React.useState(
      feedback
        ? feedback.pattern_acceptance_comments === null
          ? ""
          : feedback.pattern_acceptance_comments
        : ""
    );

  const [
    pattern_severity_scoreAcceptenceToggle,
    setpattern_severity_scoreAcceptenceToggle,
  ] = React.useState(
    feedback
      ? feedback.pattern_severity_score_acceptance === null
        ? true
        : parseInt(feedback.pattern_severity_score_acceptance)
      : true
  );

  const [
    pattern_severity_scoreAcceptenceInput,
    setpattern_severity_scoreAcceptenceInput,
  ] = React.useState(
    feedback
      ? feedback.pattern_severity_score_acceptance_comments === null
        ? ""
        : feedback.pattern_severity_score_acceptance_comments
      : ""
  );

  const [covid_acceptanceToggle, setcovid_acceptanceToggle] = React.useState(
    feedback
      ? feedback.covid_tb_pred
        ? feedback.covid_tb_pred.covid_score_prediction === null
          ? true
          : parseInt(feedback.covid_tb_pred.covid_score_prediction)
        : true
      : true
  );

  const [covid_acceptanceInput, setcovid_acceptanceInput] = React.useState(
    feedback
      ? feedback.covid_tb_pred
        ? feedback.covid_tb_pred.covid_score_prediction_comments == null
          ? ""
          : feedback.covid_tb_pred.covid_score_prediction_comments
        : ""
      : ""
  );

  const [tb_acceptanceToggle, settb_acceptanceToggle] = React.useState(
    feedback
      ? feedback.covid_tb_pred
        ? feedback.covid_tb_pred.tb_score_prediction === null
          ? true
          : parseInt(feedback.covid_tb_pred.tb_score_prediction)
        : true
      : true
  );

  const [tb_acceptanceInput, settb_acceptanceInput] = React.useState(
    feedback
      ? feedback.covid_tb_pred
        ? feedback.covid_tb_pred.tb_score_prediction_comments === null
          ? ""
          : feedback.covid_tb_pred.tb_score_prediction_comments
        : ""
      : ""
  );

  const [remarks, setRemarks] = React.useState(
    feedback ? (feedback.comments === null ? "" : feedback.comments) : ""
  );

  const [submitClicked, setSubmitClicked] = React.useState(false);

  const onSubmitFeedback = () => {
    setLoading(true);
    setSubmitClicked(true);

    let error = false;

    if (riskAcceptanceToggle == 0) {
      if (riskAcceptanceComment == "") {
        error = true;
      }
    }
    if (severityAcceptanceToggle == 0) {
      if (severityAcceptanceComment == "") {
        error = true;
      }
    }

    if (patternAcceptanceToggle == 0) {
      if (patternAcceptanceComment == "") {
        error = true;
      }
    }

    if (pattern_severity_scoreAcceptenceToggle == 0) {
      if (pattern_severity_scoreAcceptenceInput == "") {
        error = true;
      }
    }
    //  tb-likely
    if (tbriskAcceptanceToggle == 0) {
      if (tbriskAcceptanceComment == "") {
        error = true;
      }
    }
    //  tb-risk
    if (tb_acceptanceToggle == 0) {
      if (tb_acceptanceInput == "") {
        error = true;
      }
    }
    if (covidriskAcceptanceToggle == 0) {
      if (covidriskAcceptanceComment == "") {
        error = true;
      }
    }
    if (covid_acceptanceToggle == 0) {
      if (covid_acceptanceInput == "") {
        error = true;
      }
    }

    let formData = new FormData();
    formData.append("doctorId", data.doctorId);
    formData.append("recordId", data.recordId);
    formData.append("risk_acceptance", riskAcceptanceToggle ? 1 : 0);
    formData.append("risk_acceptance_comments", riskAcceptanceComment);

    if (localStorage.plan == "covid") {
      formData.append("covid_score_prediction", covid_acceptanceToggle ? 1 : 0);
      formData.append("covid_score_prediction_comments", covid_acceptanceInput);
      formData.append("covid_acceptance", covidriskAcceptanceToggle ? 1 : 0);
      formData.append("covid_acceptance_comments", covidriskAcceptanceComment);
    }

    if (localStorage.Tb == "tb") {
      formData.append("tb_score_prediction", tb_acceptanceToggle ? 1 : 0);
      formData.append("tb_score_prediction_comments", tb_acceptanceInput);
      formData.append("tb_acceptance", tbriskAcceptanceToggle ? 1 : 0);
      formData.append("tb_acceptance_comments", tbriskAcceptanceComment);
    }

    formData.append("comments", remarks);
    formData.append("severity_acceptance", severityAcceptanceToggle ? 1 : 0);
    formData.append("severity_acceptance_comments", severityAcceptanceComment);
    formData.append("pattern_acceptance", patternAcceptanceToggle ? 1 : 0);
    formData.append("pattern_acceptance_comments", patternAcceptanceComment);
    formData.append(
      "pattern_severity_score_acceptance",
      pattern_severity_scoreAcceptenceToggle ? 1 : 0
    );
    formData.append(
      "pattern_severity_score_acceptance_comments",
      pattern_severity_scoreAcceptenceInput
    );

    if (error) {
      setLoading(false);
      NotificationManager.error("Please Enter Comments", "Error", 3000);
      setSubmitClicked(false);
    } else {
      axios({
        method: "POST",
        url: "/assessmentFeedback",
        data: formData,
        headers: {
          accessToken: localStorage.accessToken,
        },
      })
        .then((response) => {
          setLoading(false);
          NotificationManager.success(
            "Your feedback has been submitted",
            "Success",
            3000
          );
          setSubmitClicked(false);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                NotificationManager.error(
                  error.response.data.message,
                  "Error",
                  5000
                );
              } else {
                NotificationManager.error(
                  "Unable to submit feedback",
                  "Error",
                  3000
                );
              }
            } else {
              NotificationManager.error(
                "Unable to submit feedback",
                "Error",
                3000
              );
            }
          } else {
            NotificationManager.error(
              "Unable to submit feedback",
              "Error",
              3000
            );
          }

          setSubmitClicked(false);
        });
    }
    error = false;
  };

  // function categorizeRisk(score) {
  //   if (score >= 7) {
  //     return "High";
  //   } else if (score >= 4) {
  //     return "Medium";
  //   } else {
  //     return "Low";
  //   }
  // }

  function categorizeRisk(score) {
    if (score === undefined || score === null) {
      return "-";
    } else if (score >= 7) {
      return "High";
    } else if (score >= 4) {
      return "Medium";
    } else {
      return "Low";
    }
  }

  if (symptoms && typeof symptoms === "object") {
    var filteredSymptoms = Object.entries(symptoms).filter(
      ([key, value]) => value === 1
    );
    // console.log(filteredSymptoms);
  } else {
    var filteredSymptoms = [];
  }

  if (medicalConditions && typeof medicalConditions === "object") {
    var filteredMedicalConditions = Object.entries(medicalConditions).filter(
      ([key, value]) => value === 1
    );
    // console.log("filtered medical conditions",filteredMedicalConditions);
  } else {
    var filteredMedicalConditions = [];
  }

  // const convertToNormalCase = (str) => {
  //   const trimmedStr = str.trim().replace(/_/g, " "); // Remove leading/trailing whitespaces and replace underscores with spaces
  //   if (trimmedStr.length === 0) return ""; // Handle empty string

  //   const firstChar = trimmedStr.charAt(0).toUpperCase();
  //   const restOfStr = trimmedStr.slice(1).toLowerCase();

  //   return firstChar + restOfStr;
  // };

  const convertToNormalCase = (str) => {
    const trimmedStr = str.trim().replace(/_/g, " "); // Remove leading/trailing whitespaces and replace underscores with spaces
    if (trimmedStr.length === 0) return ""; // Handle empty string

    if (trimmedStr.toLowerCase() === "wheezing") {
      return "Sound in chest while breathing";
    }

    const firstChar = trimmedStr.charAt(0).toUpperCase();
    const restOfStr = trimmedStr.slice(1).toLowerCase();

    return firstChar + restOfStr;
  };

  const symptomNames = filteredSymptoms.map((each) =>
    convertToNormalCase(each[0])
  );

  const medicalConditionsNames = filteredMedicalConditions.map((each) =>
    convertToNormalCase(each[0])
  );

  const toggleMedicalConditions = () => {
    setMedicalConditionsOpen(!medicalConditionsToggle);
    setLabelDataOpen(false);
    setFeedbackOpen(false);
    setVitalsAndSymptomsOpen(false);
  };

  const toggleLabelData = () => {
    setLabelDataOpen(!labelDataToggle);
    setMedicalConditionsOpen(false);
    setFeedbackOpen(false);
    setVitalsAndSymptomsOpen(false);
  };

  const toggleFeedback = () => {
    setFeedbackOpen(!feedbackToggle);
    setMedicalConditionsOpen(false);
    setLabelDataOpen(false);
    setVitalsAndSymptomsOpen(false);
  };

  const toggleVitalsAndSymptoms = () => {
    setVitalsAndSymptomsOpen(!vitalsAndSymptomsToggle);
    setFeedbackOpen(false);
    setMedicalConditionsOpen(false);
    setLabelDataOpen(false);
  };

  const addLabel = () => {
    setShowLabelData(true);
    setSelectedDiseaseOptions([]);
    setSelectedCoughOptions([]);
    setSelectedAnatomyOptions([]);
    setSelectedLabelTypeOption([]);
    setSelectedPatternOptions([]);
    setSelectedSeverityOption([]);
    setCommentType([]);
  };

  const cancelLabel = () => {
    setShowLabelData(false);
  };

  const cancel1stLabel = () => {
    setHide(true);
  };

  const handleMode = (index) => {
    setEditIndex(index);
  };
  // console.log("length", labelData.length);
  const labelDataLength = labelData ? labelData.length : null;

  // console.log("prop data",data)
  console.log(labelData);

  return (
    <div className="modal-overlay">
      <div
        className={showModal ? "assessment-modal" : "assessment-modal-close"}
      >
        <div className="modal-header">
          <div className="report-container">
            <h4 style={{ color: "#000" }}>Report</h4>
            {localStorage.validation !== "true" && (
              <div
                className="download-button-container"
                onClick={getDownloadedAssessmentReport}
              >
                <p className="download-para">Download</p>
                {downloadLoading ? (
                  <ClipLoader color={"white"} size={18} />
                ) : (
                  <img
                    src={DownloadIcon}
                    className="download-report-icon"
                    alt="download"
                  />
                )}
              </div>
            )}
          </div>
          <button className="close-button" onClick={() => onClose()}>
            Close <span style={{ color: "#595f64" }}>{">>"}</span>
          </button>
        </div>
        <div className="modal-content">
          <div className="name-date-time-container">
            <div style={{ display: "flex" }}>
              <img src={profileIcon} className="profile-icon" alt="patient" />
              <div className="assessmentId-and-name">
                <h4 className="profile-name">{name}</h4>
                <p className="record-id">
                  {" "}
                  <span
                    style={{
                      color: "#000",
                      fontWeight: "600",
                      fontSize: "12px",
                    }}
                  >
                    AssessmentId:{" "}
                  </span>{" "}
                  {data.recordId}
                </p>
                {localStorage.role === "admin" && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      margin: "4px 0 0 0",
                    }}
                  >
                    <p className="assessed-by">assessed by:</p>
                    {/* <img className="profile-icon2" src={profileIcon} alt="" /> */}
                    <h4
                      style={{
                        color: "#15294b",
                        fontWeight: "500",
                        fontSize: "12px",
                        marginLeft: "5px",
                      }}
                      className="record-id"
                    >
                      {doctorId}
                    </h4>
                  </div>
                )}
              </div>
            </div>
            {/* <div> */}
            <p className="day-month">
              {data.day &&
                data.month &&
                data.year &&
                data.time &&
                `${data.day} ${data.month}, ${data.year} / ${data.time}`}
            </p>
          </div>
          {(localStorage.validation !== "true" ||
            localStorage.longitudinal_study === "true") && (
            <>
              <div className="predictions-container">
                <h1 className="predictions-title">Predictions</h1>
                <div style={{ display: "flex" }}>
                  <div className="predictions-content">
                    <div className="predictions-section">
                      {localStorage.lhi === "true" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">Lung Health Index</p>
                          <p className="prediction-value">
                            {categorizeRisk(data.LHIIndex)}
                          </p>
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="prediction-item">
                        <p className="prediction-label">Risk</p>
                        <p className="prediction-value">
                          {data.underLyingRisk === "Yes"
                            ? "Abnormal"
                            : "Normal"}
                        </p>
                      </div>
                    </div>
                    <div className="predictions-section">
                      <div className="prediction-item">
                        <p className="prediction-label">Pattern</p>
                        <p className="prediction-value">{data.pattern}</p>
                      </div>
                      <div className="prediction-item">
                        <p className="prediction-label">Pattern Severity</p>
                        <p className="prediction-value">
                          {data.patternSeverity}
                        </p>
                      </div>
                    </div>
                    <div className="predictions-section">
                      <div className="prediction-item">
                        <p className="prediction-label">Wetness Percentage</p>
                        <p className="prediction-value">
                          {data.percentage_of_wetness == null
                            ? "-"
                            : data.percentage_of_wetness}
                        </p>
                      </div>
                    </div>
                  </div>
                  <p className="predictions-line"></p>

                  <div className="predictions-content">
                    <div className="predictions-section-likely">
                      {localStorage.Tb === "tb" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">TB Likely</p>
                          <p className="prediction-value">
                            {data.TBLikely ? data.TBLikely : "-"}
                          </p>
                        </div>
                      ) : null}
                      {localStorage.plan === "covid" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">COVID Likely</p>
                          <p className="prediction-value">
                            {data.covidLikely ? data.covidLikely : "-"}
                          </p>
                        </div>
                      ) : null}

                      {localStorage.asthma === "asthma" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">Asthma Likely</p>
                          <p className="prediction-value">
                            {data.AsthmaLikely ? data.AsthmaLikely : "-"}
                          </p>
                        </div>
                      ) : null}
                      {localStorage.copd === "copd" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">COPD Likely</p>
                          <p className="prediction-value">
                            {data.COPDLikely ? data.COPDLikely : "-"}
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="predictions-content">
                    <div className="predictions-section-likely">
                      {localStorage.Tb === "tb" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">TB Risk</p>
                          <p className="prediction-value">
                            {categorizeRisk(data.TBRiskScore)}
                          </p>
                        </div>
                      ) : null}
                      {localStorage.plan === "covid" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">COVID Risk</p>
                          <p className="prediction-value">
                            {categorizeRisk(data.covidRiskScore)}
                          </p>
                        </div>
                      ) : null}
                      {localStorage.asthma === "asthma" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">Asthma Risk</p>
                          <p className="prediction-value">
                            {categorizeRisk(data.asthmaRiskScore)}
                          </p>
                        </div>
                      ) : null}
                      {localStorage.copd === "copd" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">COPD Risk</p>
                          <p className="prediction-value">
                            {categorizeRisk(data.COPDRiskScore)}
                          </p>
                        </div>
                      ) : null}
                    </div>
                    <div className="predictions-section-likely">
                      {localStorage.spirometry === "spirometry" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">FVC</p>
                          <p className="prediction-value">
                            {data.fvc === null
                              ? "-"
                              : parseFloat(data.fvc).toFixed(2)}
                          </p>
                        </div>
                      ) : null}
                      {localStorage.spirometry === "spirometry" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">FEV1</p>
                          <p className="prediction-value">
                            {data.fev1 === null
                              ? "-"
                              : parseFloat(data.fev1).toFixed(2)}
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="predictions-content">
                    <div className="predictions-section-likely">
                      {localStorage.spirometry === "spirometry" ? (
                        <div className="prediction-item">
                          <p className="prediction-label">FEV1/FVC</p>
                          <p className="prediction-value">
                            {data.fev1fvc === null
                              ? "-"
                              : parseFloat(data.fev1fvc).toFixed(2)}
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {/* Cough sound & Characteristics */}
          <div className="cough-sample-container">
            <div style={{ width: "60%" }}>
              <h1
                style={{
                  color: " #ff7208",
                  fontFamily: "Roboto",
                  fontSize: "15px",
                  fontWeight: "600",
                  marginTop: "5px",
                  marginBottom: "8px",
                }}
              >
                Cough Sample
              </h1>
              <div></div>
              <div style={{ height: "100px" }}>
                {record && <AudioPlayer audio={record} />}
              </div>
            </div>
            <p className="vertical-line"></p>
            <div className="cough-counts">
              <p className="cough-count">
                Cough Count{" "}
                <span style={{ marginLeft: "0.8em", fontSize: "14px" }}>
                  {data.dryCount + data.wetCount}{" "}
                </span>
              </p>
              <p className="cough-count">
                Dry Count{" "}
                <span style={{ marginLeft: "2em", fontSize: "14px" }}>
                  {data.dryCount}
                </span>
              </p>
              <p className="cough-count">
                Wet Count{" "}
                <span style={{ marginLeft: "1.9em", fontSize: "14px" }}>
                  {data.wetCount}{" "}
                </span>{" "}
              </p>
            </div>
          </div>
          {/* Medical conditons */}
          <div className="dropdowns-container">
            {localStorage.plan === "covid" && (
              <div className="dropdown-container">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "0.9em",
                  }}
                >
                  <h4 className="dropdown-heading">Medical Conditions</h4>
                  {medicalConditionsToggle ? (
                    <div
                      onClick={toggleMedicalConditions}
                      className="expand-container"
                    >
                      <p>Close</p>
                      <img src={UpArrow} alt="" className="close-icon" />
                    </div>
                  ) : (
                    <div
                      onClick={toggleMedicalConditions}
                      className="expand-container"
                    >
                      <p>Expand</p>
                      <img src={DownArrow} className="expand-icon" alt="" />
                    </div>
                  )}
                </div>
                {medicalConditionsToggle &&
                  (data.medicalConditions ? (
                    <div>
                      {medicalConditionsNames.map((each, index) => (
                        <p
                          key={index}
                          style={{
                            color: "#29353f",
                            fontFamily: "Roboto",
                            fontSize: "12px",
                            fontWeight: "500",
                            boxSizing: "border-box",
                            margin: "0.4em",
                            textAlign: "left",
                          }}
                        >
                          {each}
                        </p>
                      ))}
                    </div>
                  ) : (
                    <p style={{ textAlign: "center", margin: "0 0 15px 0" }}>
                      No medical conditons
                    </p>
                  ))}
              </div>
            )}
          </div>
          {/* Score & Feedback */}
          <div className="dropdowns-container">
            <div className="dropdown-container">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "0.9em",
                }}
              >
                <h4 className="dropdown-heading">Score & Feedback</h4>
                {feedbackToggle ? (
                  <div onClick={toggleFeedback} className="expand-container">
                    <p>Close</p>
                    <img src={UpArrow} alt="" className="close-icon" />
                  </div>
                ) : (
                  <div onClick={toggleFeedback} className="expand-container">
                    <p>Expand</p>
                    <img src={DownArrow} className="expand-icon" alt="" />
                  </div>
                )}
              </div>
              {feedbackToggle && (
                <div>
                  <div className="feedback-custom">
                    <h1 className="feedback-heading">
                      Send us a feedback
                      <span className="feedback-span">(mandatory)</span>{" "}
                    </h1>
                    <h4 className="feedback-heading2">
                      Toggle on if any prediction is wrong
                    </h4>
                    <div className="switch-custom">
                      <label className="switch-label">
                        <Switch
                          onColor="#ff7d00"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={13}
                          width={24}
                          className="switch-toggle"
                          handleDiameter={5}
                          borderRadius={15}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          onChange={() =>
                            setriskAcceptanceToggle(!riskAcceptanceToggle)
                          }
                          checked={riskAcceptanceToggle}
                        />
                        <p className="label-span">Risk Prediction</p>
                      </label>
                      {!riskAcceptanceToggle && (
                        <>
                          <textarea
                            placeholder="Please provide expected Risk(Abnormal/Normal/Other)"
                            className="switch-textarea"
                            value={riskAcceptanceComment}
                            onChange={(e) =>
                              setriskAcceptanceComment(e.target.value)
                            }
                          ></textarea>
                        </>
                      )}
                    </div>

                    <div className="switch-custom">
                      <label className="switch-label">
                        <Switch
                          onColor="#ff7d00"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={13}
                          className="switch-toggle"
                          width={24}
                          handleDiameter={5}
                          borderRadius={15}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          onChange={() =>
                            setpatternAcceptanceToggle(!patternAcceptanceToggle)
                          }
                          checked={patternAcceptanceToggle}
                        />
                        <span className="label-span">Pattern prediction</span>
                      </label>
                      {!patternAcceptanceToggle && (
                        <>
                          <textarea
                            placeholder="Please provide expected Pattern(Obstructive/Restrictive/Mixed/Normal)"
                            className="switch-textarea"
                            value={patternAcceptanceComment}
                            onChange={(e) =>
                              setpatternAcceptanceComment(e.target.value)
                            }
                          ></textarea>
                        </>
                      )}
                    </div>

                    <div className="switch-custom">
                      <label className="switch-label">
                        <Switch
                          onColor="#ff7d00"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={13}
                          width={24}
                          className="switch-toggle"
                          handleDiameter={5}
                          borderRadius={15}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          onChange={() =>
                            setseverityAcceptanceToggle(
                              !severityAcceptanceToggle
                            )
                          }
                          checked={severityAcceptanceToggle}
                        />
                        <span className="label-span">
                          Pattern severity prediction
                        </span>
                      </label>
                      {!severityAcceptanceToggle && (
                        <>
                          <textarea
                            placeholder="Please provide expected Pattern Severity(Low/Medium/High/Normal)"
                            className="switch-textarea"
                            value={severityAcceptanceComment}
                            onChange={(e) =>
                              setseverityAcceptanceComment(e.target.value)
                            }
                          ></textarea>
                        </>
                      )}
                    </div>

                    <div className="switch-custom">
                      <label className="switch-label">
                        <Switch
                          onColor="#ff7d00"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={13}
                          width={24}
                          className="switch-toggle"
                          handleDiameter={5}
                          borderRadius={15}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          onChange={() =>
                            setpattern_severity_scoreAcceptenceToggle(
                              !pattern_severity_scoreAcceptenceToggle
                            )
                          }
                          checked={pattern_severity_scoreAcceptenceToggle}
                        />
                        <span className="label-span">Lung Health Index</span>
                      </label>
                      {!pattern_severity_scoreAcceptenceToggle && (
                        <>
                          <textarea
                            placeholder="Please provide expected Lung Health Index(Low/Medium/High/Normal)"
                            className="switch-textarea"
                            value={pattern_severity_scoreAcceptenceInput}
                            onChange={(e) =>
                              setpattern_severity_scoreAcceptenceInput(
                                e.target.value
                              )
                            }
                          ></textarea>
                        </>
                      )}
                    </div>

                    {localStorage.Tb === "tb" ? (
                      <div className="switch-custom">
                        <label className="switch-label">
                          <Switch
                            onColor="#ff7d00"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={13}
                            width={24}
                            className="switch-toggle"
                            handleDiameter={5}
                            borderRadius={15}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            onChange={() =>
                              settbriskAcceptanceToggle(!tbriskAcceptanceToggle)
                            }
                            checked={tbriskAcceptanceToggle}
                          />
                          <span className="label-span">TB likely</span>
                        </label>
                        {!tbriskAcceptanceToggle && (
                          <>
                            <textarea
                              placeholder="Please provide expected TB Likely Detection(Yes/No)"
                              className="switch-textarea"
                              value={tbriskAcceptanceComment}
                              onChange={(e) => {
                                // console.log(e.target.value);
                                settbriskAcceptanceComment(e.target.value);
                              }}
                            ></textarea>
                          </>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}

                    {localStorage.Tb === "tb" ? (
                      <div className="switch-custom">
                        <label className="switch-label">
                          <Switch
                            onColor="#ff7d00"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={13}
                            className="switch-toggle"
                            width={24}
                            handleDiameter={5}
                            borderRadius={15}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            onChange={() =>
                              settb_acceptanceToggle(!tb_acceptanceToggle)
                            }
                            checked={tb_acceptanceToggle}
                          />
                          <span className="label-span">TB Risk</span>
                        </label>
                        {!tb_acceptanceToggle && (
                          <>
                            <textarea
                              placeholder="Please provide expected TB Risk(Low/Medium/High/Normal)"
                              className="switch-textarea"
                              value={tb_acceptanceInput}
                              onChange={(e) => {
                                // console.log(e.target.value);
                                settb_acceptanceInput(e.target.value);
                              }}
                            ></textarea>
                          </>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                    {localStorage.plan === "covid" ? (
                      <div className="switch-custom">
                        <label className="switch-label">
                          <Switch
                            onColor="#ff7d00"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={13}
                            width={24}
                            className="switch-toggle"
                            handleDiameter={5}
                            borderRadius={15}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            onChange={() =>
                              setcovidriskAcceptanceToggle(
                                !covidriskAcceptanceToggle
                              )
                            }
                            checked={covidriskAcceptanceToggle}
                          />
                          <span className="label-span">COVID likely</span>
                        </label>
                        {!covidriskAcceptanceToggle && (
                          <>
                            <textarea
                              placeholder="Please provide expected COVID Likely Detection(Yes/No)"
                              className="switch-textarea"
                              value={covidriskAcceptanceComment}
                              onChange={(e) =>
                                setcovidriskAcceptanceComment(e.target.value)
                              }
                            ></textarea>
                          </>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                    {localStorage.plan === "covid" ? (
                      <div className="switch-custom">
                        <label className="switch-label">
                          <Switch
                            onColor="#ff7d00"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={13}
                            width={24}
                            className="switch-toggle"
                            handleDiameter={5}
                            borderRadius={15}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            style={{ paddingTop: "5px" }}
                            onChange={() =>
                              setcovid_acceptanceToggle(!covid_acceptanceToggle)
                            }
                            checked={covid_acceptanceToggle}
                          />
                          <span className="label-span">COVID Risk</span>
                        </label>
                        {!covid_acceptanceToggle && (
                          <>
                            <textarea
                              placeholder="Please provide expected COVID Risk(Low/Medium/High/Normal)"
                              className="switch-textarea"
                              value={covid_acceptanceInput}
                              onChange={(e) =>
                                setcovid_acceptanceInput(e.target.value)
                              }
                            ></textarea>
                          </>
                        )}
                        {/* Hide checkbox visually */}
                        <style>{`
                              .switch-label input[type="checkbox"] {
                                position: absolute;
                                opacity: 0;
                                height: 0;
                                width: 0;
                              }
                            `}</style>
                      </div>
                    ) : (
                      <></>
                    )}

                    <div className="switch-custom">
                      <label className="switch-label remarks">
                        Add Remarks
                      </label>
                      <textarea
                        placeholder="Please provide patient condition(Upper Respiratory Tract Infection(UTRI), Influenza-like Illness(ILI), Allergy, Asthma, COPD, Pneumonia, Bronchitis, ILD, TB, COVID or any other"
                        className="switch-textarea remarks-textarea"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      ></textarea>
                    </div>

                    <div className="patient-report-feedback">
                      {loading ? (
                        <div
                          className="submit-feedback"
                          style={{ textAlign: "center", paddingTop: "8px" }}
                        >
                          <ClipLoader color="white" size={25} />
                        </div>
                      ) : (
                        <button
                          onClick={() => onSubmitFeedback()}
                          disabled={submitClicked}
                          className="submit-feedback"
                        >
                          Submit Feedback
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* Vitals & Symptoms */}
          <div className="dropdowns-container">
            <div className="dropdown-container">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "0.9em",
                }}
              >
                <h4 className="dropdown-heading"> Vitals & Symptoms</h4>
                {vitalsAndSymptomsToggle ? (
                  <div
                    onClick={toggleVitalsAndSymptoms}
                    className="expand-container"
                  >
                    <p>Close</p>
                    <img src={UpArrow} alt="" className="close-icon" />
                  </div>
                ) : (
                  <div
                    onClick={toggleVitalsAndSymptoms}
                    className="expand-container"
                  >
                    <p>Expand</p>
                    <img src={DownArrow} className="expand-icon" alt="" />
                  </div>
                )}
              </div>
              {vitalsAndSymptomsToggle && (
                <>
                  <div className="vital-major-container">
                    <h1 className="vitals-heading">Vitals</h1>
                    <div className="vital-main-container">
                      <div>
                        <div className="vital-container">
                          <p className="vital-para">Pulse Rate</p>
                          {symptoms.pulse_rate === null ||
                          symptoms.pulse_rate === "0" ||
                          symptoms.pulse_rate === undefined ||
                          !symptoms.pulse_rate ? (
                            <p className="vital-value">-</p>
                          ) : (
                            <p className="vital-value">
                              {symptoms.pulse_rate} beats/min
                            </p>
                          )}
                        </div>
                        <div className="vital-container">
                          <p className="vital-para">Oxygen Saturation</p>
                          {symptoms.oxygen_saturation === null ||
                          symptoms.oxygen_saturation === "0" ||
                          symptoms.oxygen_saturation === undefined ||
                          !symptoms.oxygen_saturation ? (
                            <p className="vital-value">-</p>
                          ) : (
                            <p className="vital-value">
                              {symptoms.oxygen_saturation} %
                            </p>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="vital-container">
                          <p className="vital-para">Temperature</p>
                          {symptoms.temperature_F === null ||
                          symptoms.temperature_F === "0" ||
                          symptoms.temperature_F === undefined ||
                          !symptoms.temperature_F ? (
                            <p className="vital-value">-</p>
                          ) : (
                            <p className="vital-value">
                              {symptoms.respiratory_rate} F
                            </p>
                          )}
                        </div>
                        <div className="vital-container">
                          <p className="vital-para">Respiratory Rate</p>
                          {symptoms.respiratory_rate === null ||
                          symptoms.respiratory_rate === "0" ||
                          symptoms.respiratory_rate === undefined ||
                          !symptoms.respiratory_rate ? (
                            <p className="vital-value">-</p>
                          ) : (
                            <p className="vital-value">
                              {symptoms.respiratory_rate} breaths/min
                            </p>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="vital-container">
                          <p className="vital-para">Blood Pressure</p>
                          {symptoms.blood_pressure === null ||
                          symptoms.blood_pressure === "0" ||
                          symptoms.blood_pressure === "/" ||
                          symptoms.blood_pressure === undefined ||
                          !symptoms.blood_pressure ? (
                            <p className="vital-value">-</p>
                          ) : (
                            <p className="vital-value">
                              {symptoms.blood_pressure} mmHg
                              </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="symptoms-values-container">
                    <div className="symptoms-container">
                      <h1 className="symptoms-heading">Symptoms</h1>
                      {symptomNames.length === 0 ? (
                        <p
                          style={{
                            textAlign: "center",
                            fontFamily: "Roboto",
                            fontSize: "14px",
                            margin: "16px 0 15px 0",
                          }}
                        >
                          No symptoms
                        </p>
                      ) : (
                        <div
                          className="symptoms-wrapper"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            margin: "0.4em",
                            marginLeft: "0",
                            flexWrap: "wrap",
                          }}
                        >
                          <div className="symptoms-column">
                            {symptomNames
                              .slice(0, Math.ceil(symptomNames.length / 2))
                              .map((each, index) => (
                                <p
                                  key={index}
                                  style={{
                                    color: "#29353f",
                                    fontFamily: "Roboto",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    boxSizing: "border-box",
                                    margin: "0.4em",
                                    textAlign: "left",
                                  }}
                                >
                                  {each}
                                </p>
                              ))}
                          </div>

                          <div className="vertical-line-symptoms"></div>

                          <div className="symptoms-column">
                            {symptomNames
                              .slice(Math.ceil(symptomNames.length / 2))
                              .map((each, index) => (
                                <p
                                  key={index}
                                  style={{
                                    color: "#29353f",
                                    fontFamily: "Roboto",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    boxSizing: "border-box",
                                    margin: "0.4em",
                                    textAlign: "left",
                                  }}
                                >
                                  {each}
                                </p>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {localStorage.labelling === "true" && (
            <div className="dropdowns-container">
              <div className="dropdown-container">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "0.9em",
                  }}
                >
                  <h4 className="dropdown-heading">Label Data</h4>
                  {/* <div style={{display:'flex', flexDirection: 'row', alignItems: 'center'}} onClick={cancelLabel} >
                      <p style={{cursor: 'pointer'}} className="cancel-btn" >Cancel</p>
                      <img className="cancel-img" src={RemoveRectangle} alt='close'/>
                    </div> */}
                  {labelDataToggle ? (
                    <div onClick={toggleLabelData} className="expand-container">
                      <p>Close</p>
                      <img src={UpArrow} alt="" className="close-icon" />
                    </div>
                  ) : (
                    <div onClick={toggleLabelData} className="expand-container">
                      <p>Expand</p>
                      <img src={DownArrow} className="expand-icon" alt="" />
                    </div>
                  )}
                </div>
                {labelDataLength !== null
                  ? labelDataLength >= 1
                    ? labelDataToggle &&
                      labelData.map((item, index) =>
                        !loading ? (
                          <div key={index}>
                            <LabelReadMode
                              index={index}
                              editLabelData={labelData}
                              getPatientRecords1={getPatientRecords1}
                              recordId={data.recordId}
                              readModeData={item.data}
                              isEditMode={handleMode}
                              editMode={index === editIndex ? true : false}
                              customStyles={customStyles}
                              diseaseOptions={diseaseOptions}
                              coughOptions={coughOptions}
                              patternOptions={patternOptions}
                              severityOptions={severityOptions}
                              anatomyOptions={anatomyOptions}
                              labelTypeOptions={labelTypeOptions}
                              isOptionDisabled={isOptionDisabled}
                            />
                          </div>
                        ) : (
                          <></>
                        )
                      )
                    : labelDataToggle &&
                      (!hide ? (
                        <div>
                          <div className="label-container">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingBottom: "10px",
                              }}
                            >
                              <p className="read-mode-heading">
                                Labelling Data #{labelData.length + 1}
                              </p>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                                onClick={cancel1stLabel}
                              >
                                <p
                                  style={{ cursor: "pointer" }}
                                  className="cancel-btn"
                                >
                                  Cancel
                                </p>
                                <img
                                  className="cancel-img"
                                  src={RemoveRectangle}
                                  alt="close"
                                />
                              </div>
                            </div>
                            {/* <DynamicReports onPdfUpload={handlePdfUpload} /> */}
                            <h5 className="label-heading">Disease</h5>
                            <Select
                              options={diseaseOptions}
                              value={selectedDiseaseOptions}
                              onChange={changeDisease}
                              isMulti={true}
                              isOptionDisabled={isOptionDisabled}
                              styles={customStyles}
                              placeholder="Multiple Select"
                              closeMenuOnSelect={false}
                            />
                          </div>
                          <div className="label-container">
                            <h5 className="label-heading">Cough Type</h5>
                            <Select
                              options={coughOptions}
                              value={selectedCoughOptions}
                              onChange={changeCough}
                              isMulti={true}
                              isOptionDisabled={isOptionDisabled}
                              styles={customStyles}
                              placeholder="Multiple Select"
                              closeMenuOnSelect={false}
                            />
                          </div>
                          <div className="label-container">
                            <h5 className="label-heading">Pattern</h5>
                            <Select
                              options={patternOptions}
                              value={selectedPatternOptions}
                              onChange={changePattern}
                              isMulti={true}
                              isOptionDisabled={isOptionDisabled}
                              styles={customStyles}
                              placeholder="Multiple Select"
                              closeMenuOnSelect={false}
                            />
                          </div>
                          <div className="label-container">
                            <h5 className="label-heading">Severity</h5>
                            <Select
                              options={severityOptions}
                              value={selectedSeverityOption}
                              onChange={changeSeverity}
                              styles={customStyles}
                              placeholder="Select"
                            />
                          </div>
                          <div className="label-container">
                            <h5 className="label-heading">Anatomy</h5>
                            <Select
                              options={anatomyOptions}
                              value={selectedAnatomyOptions}
                              onChange={changeAnatomy}
                              isMulti={true}
                              isOptionDisabled={isOptionDisabled}
                              styles={customStyles}
                              placeholder="Multiple Select"
                              closeMenuOnSelect={false}
                            />
                          </div>
                          <div className="label-container">
                            <h5 className="label-heading">Label Type *</h5>
                            <Select
                              options={labelTypeOptions}
                              value={selectedLabelTypeOption}
                              onChange={changeLabelType}
                              styles={customStyles}
                              placeholder="Select"
                            />
                            {isLabelTypeRequired && (
                              <p className="label-error">
                                Please select label type
                              </p>
                            )}
                          </div>
                          <div>
                            <h5 className="label-heading">Comment</h5>
                            <textarea
                              placeholder="Type"
                              value={commentType}
                              className="comment-textarea"
                              onChange={(e) => setCommentType(e.target.value)}
                            ></textarea>
                          </div>
                          <div className="patient-report-feedback">
                            {loading ? (
                              <div
                                className="submit-feedback"
                                style={{
                                  textAlign: "center",
                                  paddingTop: "8px",
                                }}
                              >
                                <ClipLoader color="white" size={25} />
                              </div>
                            ) : (
                              <button
                                className="submit-feedback"
                                type="button"
                                onClick={saveLabel}
                              >
                                Save Label
                              </button>
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      ))
                  : labelDataToggle && (
                      <div>
                        <div className="label-container">
                          {/* <DynamicReports onPdfUpload={handlePdfUpload} /> */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              paddingBottom: "10px",
                            }}
                          >
                            <p className="read-mode-heading">
                              Labelling Data {labelData.length + 1}
                            </p>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                              onClick={cancel1stLabel}
                            >
                              <p
                                style={{ cursor: "pointer" }}
                                className="cancel-btn"
                              >
                                Cancel
                              </p>
                              <img
                                className="cancel-img"
                                src={RemoveRectangle}
                                alt="close"
                              />
                            </div>
                          </div>
                          <h5 className="label-heading">Disease</h5>
                          <Select
                            options={diseaseOptions}
                            value={selectedDiseaseOptions}
                            onChange={changeDisease}
                            isMulti={true}
                            isOptionDisabled={isOptionDisabled}
                            styles={customStyles}
                            placeholder="Multiple Select"
                            closeMenuOnSelect={false}
                          />
                        </div>
                        <div className="label-container">
                          <h5 className="label-heading">Cough Type</h5>
                          <Select
                            options={coughOptions}
                            value={selectedCoughOptions}
                            onChange={changeCough}
                            isMulti={true}
                            isOptionDisabled={isOptionDisabled}
                            styles={customStyles}
                            placeholder="Multiple Select"
                            closeMenuOnSelect={false}
                          />
                        </div>
                        <div className="label-container">
                          <h5 className="label-heading">Pattern</h5>
                          <Select
                            options={patternOptions}
                            value={selectedPatternOptions}
                            onChange={changePattern}
                            isMulti={true}
                            isOptionDisabled={isOptionDisabled}
                            styles={customStyles}
                            placeholder="Multiple Select"
                            closeMenuOnSelect={false}
                          />
                        </div>
                        <div className="label-container">
                          <h5 className="label-heading">Severity</h5>
                          <Select
                            options={severityOptions}
                            value={selectedSeverityOption}
                            onChange={changeSeverity}
                            styles={customStyles}
                            placeholder="Select"
                          />
                        </div>
                        <div className="label-container">
                          <h5 className="label-heading">Anatomy</h5>
                          <Select
                            options={anatomyOptions}
                            value={selectedAnatomyOptions}
                            onChange={changeAnatomy}
                            isMulti={true}
                            isOptionDisabled={isOptionDisabled}
                            styles={customStyles}
                            placeholder="Multiple Select"
                            closeMenuOnSelect={false}
                          />
                        </div>
                        <div className="label-container">
                          <h5 className="label-heading">Label Type *</h5>
                          <Select
                            options={labelTypeOptions}
                            value={selectedLabelTypeOption}
                            onChange={changeLabelType}
                            styles={customStyles}
                            placeholder="Select"
                          />
                          {isLabelTypeRequired && (
                            <p className="label-error">
                              Please select label type
                            </p>
                          )}
                        </div>
                        <div>
                          <h5 className="label-heading">Comment</h5>
                          <textarea
                            placeholder="Type"
                            value={commentType}
                            className="comment-textarea"
                            onChange={(e) => setCommentType(e.target.value)}
                          ></textarea>
                        </div>
                        <div className="patient-report-feedback">
                          {loading ? (
                            <div
                              className="submit-feedback"
                              style={{
                                textAlign: "center",
                                paddingTop: "8px",
                              }}
                            >
                              <ClipLoader color="white" size={25} />
                            </div>
                          ) : (
                            <button
                              className="submit-feedback"
                              type="button"
                              onClick={saveLabel}
                            >
                              Save Label
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                {labelDataToggle && (
                  <div className="add-data-set-container" onClick={addLabel}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                        stroke="#FF7D00"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.25 12H15.75"
                        stroke="#FF7D00"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 8.25V15.75"
                        stroke="#FF7D00"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p className="add-data-set">Add Label</p>
                  </div>
                )}
                {showLabelData && labelDataToggle && (
                  <div>
                    <div className="label-container">
                      {/* <DynamicReports onPdfUpload={handlePdfUpload} /> */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingBottom: "10px",
                        }}
                      >
                        <p className="read-mode-heading">
                          Labelling Data {labelData.length + 1}
                        </p>
                        {/* <button onClick={cancelLabel}>Cancel</button> */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                          onClick={cancelLabel}
                        >
                          <p
                            style={{ cursor: "pointer" }}
                            className="cancel-btn"
                          >
                            Cancel
                          </p>
                          <img
                            className="cancel-img"
                            src={RemoveRectangle}
                            alt="close"
                          />
                        </div>
                        {/* <div style={{display:'flex',justifyContent:'space-between',paddingBottom:'10px'}} >
                          <p  className="read-mode-heading">Labelling Data #{index+1}</p>
                          <div style={{display:'flex', flexDirection: 'row', alignItems: 'center'}} onClick={cancelEditLabel} >
                          <p style={{cursor: 'pointer'}} className="cancel-btn" >Cancel</p>
                          <img className="cancel-img" src={RemoveRectangle} alt='close'/>
                          </div>
                        </div> */}
                      </div>
                      <h5 className="label-heading">Disease</h5>
                      <Select
                        options={diseaseOptions}
                        value={selectedDiseaseOptions}
                        onChange={changeDisease}
                        isMulti={true}
                        isOptionDisabled={isOptionDisabled}
                        styles={customStyles}
                        placeholder="Multiple Select"
                        closeMenuOnSelect={false}
                      />
                    </div>
                    <div className="label-container">
                      <h5 className="label-heading">Cough Type</h5>
                      <Select
                        options={coughOptions}
                        value={selectedCoughOptions}
                        onChange={changeCough}
                        isMulti={true}
                        isOptionDisabled={isOptionDisabled}
                        styles={customStyles}
                        placeholder="Multiple Select"
                        closeMenuOnSelect={false}
                      />
                    </div>
                    <div className="label-container">
                      <h5 className="label-heading">Pattern</h5>
                      <Select
                        options={patternOptions}
                        value={selectedPatternOptions}
                        onChange={changePattern}
                        isMulti={true}
                        isOptionDisabled={isOptionDisabled}
                        styles={customStyles}
                        placeholder="Multiple Select"
                        closeMenuOnSelect={false}
                      />
                    </div>
                    <div className="label-container">
                      <h5 className="label-heading">Severity</h5>
                      <Select
                        options={severityOptions}
                        value={selectedSeverityOption}
                        onChange={changeSeverity}
                        styles={customStyles}
                        placeholder="Select"
                      />
                    </div>
                    <div className="label-container">
                      <h5 className="label-heading">Anatomy</h5>
                      <Select
                        options={anatomyOptions}
                        value={selectedAnatomyOptions}
                        onChange={changeAnatomy}
                        isMulti={true}
                        isOptionDisabled={isOptionDisabled}
                        styles={customStyles}
                        placeholder="Multiple Select"
                        closeMenuOnSelect={false}
                      />
                    </div>
                    <div className="label-container">
                      <h5 className="label-heading">Label Type *</h5>
                      <Select
                        options={labelTypeOptions}
                        value={selectedLabelTypeOption}
                        onChange={changeLabelType}
                        styles={customStyles}
                        placeholder="Select"
                      />
                      {isLabelTypeRequired && (
                        <p className="label-error">Please select label type</p>
                      )}
                    </div>
                    <div>
                      <h5 className="label-heading">Comment</h5>
                      <textarea
                        placeholder="Type"
                        value={commentType}
                        className="comment-textarea"
                        onChange={(e) => setCommentType(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="patient-report-feedback">
                      {loading ? (
                        <div
                          className="submit-feedback"
                          style={{
                            textAlign: "center",
                            paddingTop: "8px",
                          }}
                        >
                          <ClipLoader color="white" size={25} />
                        </div>
                      ) : (
                        <button
                          className="submit-feedback"
                          type="button"
                          onClick={saveLabel}
                        >
                          Save Label
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssessmentModal;
